export const isTrackingNumber = (tn: string) => {
  const trimmedTrNr = tn.trim();
  const cleanTrNr = trimmedTrNr.replace(/\W/g, "");
  if (cleanTrNr !== trimmedTrNr) {
    return false;
  }
  if (cleanTrNr !== trimmedTrNr.toUpperCase()) {
    return false;
  }
  return cleanTrNr.length >= 10 && cleanTrNr.length <= 34;
};
